import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";
import User from "@/models/User/User";
import PublicImage from "@/models/PublicImage/PublicImage";
import Topic from "@/models/WebsiteBlog/Topic/Topic";
import WebsiteRoute from "@/models/WebsiteRoute/WebsiteRoute";
import WebsiteBlogCountry from "@/models/WebsiteBlog/WebsiteBlogCountry";

export default class WebsiteBlog extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-blog';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteBlogs';

    static fields() {
		return {
			id:this.number(null).nullable(),
			published_at: this.attr(null),
			is_highlighted: this.attr(null),
			url: this.attr(null),
			title: this.attr(null),
			information: this.attr(null),
			header_public_image_id: this.number(null).nullable(),
			public_image_id: this.number(null).nullable(),
			user_id: this.number(null).nullable(),
			website_blog_topic_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
            headerPublicImage: this.belongsTo(PublicImage, 'header_public_image_id'),
            user: this.belongsTo(User, 'user_id'),
            topic: this.belongsTo(Topic, 'website_blog_topic_id'),
            countries: this.belongsToMany(Country, WebsiteBlogCountry, 'website_blog_id', 'country_id'),
            websiteRoute: this.hasOne(WebsiteRoute, 'routeable_id'),
		}
	}

    /**
     *
     * @returns {string}
     * @constructor
     */
    Url() {
        return '/blog/' + this.url;
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    WebsiteUrl() {
        return window.config.WEBSITE_URL + this.Url();
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    User() {
        return this.getRelated('user');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Countries() {
        return this.getRelated('countries');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage() {
        return this.getRelated('publicImage');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    HeaderPublicImage() {
        return this.getRelated('headerPublicImage');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Topic() {
        return this.getRelated('topic');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteRoute() {
        return WebsiteRoute.findByRouteable(this.id, 'website_blog');
    }
}
